export enum ApiResultCode {
     Ok							= 'Ok',
 
     ResultCodeNotProvided		= 'ResultCodeNotProvided',
     RequestedObjectUnreachable = 'RequestedObjectUnreachable',
     ObjectIdMissmatching       = 'ObjectIdMissmatching',
     AlreadyExists              = 'AlreadyExists',
     MissingIdentityToken       = 'MissingIdentityToken',
      
     AccessForbidden			= 'AccessForbidden',		// L'utilisateur est authentifié mais il n'a pas le droit d'accéder à la ressource demandée
      
 
     InvalidModelState			= 'InvalidModelState',
         
     InternalException			= 'InternalException',
 }